import Vue from 'vue';
import Vuex from 'vuex';
import PosFinder from "./vue/PosFinder";
import MakeStore from './Store';

Vue.use(Vuex);

/**
 * Load a unique location finder widget every time
 */

const initPos = () => {
    document.querySelectorAll('.vue-widget-posfinder').forEach(widget => {
        const mapsApiKey = widget.getAttribute('data-mapsapikey');
        const query = widget.getAttribute('data-query');
        const initialProduct = widget.getAttribute('data-product');
        const geo = widget.getAttribute('data-geo') === "1";
        const bearer = widget.getAttribute('data-bearer');
        const baseUrl = widget.getAttribute('data-baseurl');
        new Vue({
            el: widget,
            store: MakeStore(bearer,baseUrl),
            render: function (a) {
                return a(PosFinder, {
                    props: {
                        query,
                        initialProduct: parseInt(initialProduct) || -1,
                        geo,
                        mapsApiKey,
                    },
                });
            }
        });
    });
}

window.initPos = initPos;
initPos();